export default __webpack_public_path__ + "static/media/fresh_eggplants.9496483c.png";